/* eslint "react/prop-types": "warn" */
import React from "react";
import PropTypes from "prop-types";
import S from "platopulse/components/Sidebar.css";
import { t } from 'c-3po';
import Breadcrumbs from "platopulse/components/Breadcrumbs.jsx";
import SidebarItem from "platopulse/components/SidebarItem.jsx"

import cx from 'classnames';
import pure from "recompose/pure";

const BaseSidebar = ({
    style,
    className
}) =>
    <div className={cx(S.sidebar, className)} style={style}>
        <div className={S.breadcrumbs}>
            <Breadcrumbs
                className="py4"
                crumbs={[[t`Data Reference`]]}
                inSidebar={true}
                placeholder={t`Data Reference`}
            />
        </div>
        <ol>
            <SidebarItem key="/reference/guide" 
                         href="/reference/guide" 
                         icon="reference" 
                         name={t`Start here`} />
            <SidebarItem key="/reference/metrics" 
                         href="/reference/metrics" 
                         icon="ruler" 
                         name={t`Metrics`} />
            <SidebarItem key="/reference/segments" 
                         href="/reference/segments" 
                         icon="segment" 
                         name={t`Segments`} />
            <SidebarItem key="/reference/databases" 
                         href="/reference/databases" 
                         icon="database" 
                         name={t`Databases and tables`} />
        </ol>
    </div>

BaseSidebar.propTypes = {
    className:      PropTypes.string,
    style:          PropTypes.object,
};

export default pure(BaseSidebar);




// WEBPACK FOOTER //
// ./reference/guide/BaseSidebar.jsx